export { default as loaderTemplate } from './loader.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/loader/templates/index.ts